import { useMemo } from "react";

import Tooltip from "~/components/Tooltip";
import {
	getInvoiceStatusDisplayNameById,
	invoiceStatusId,
} from "~/modules/billing/api/invoiceStatus/invoiceStatusId.ts";
import type { InvoiceStatusId } from "~/modules/billing/api/processedInvoice/processedInvoiceTypes.ts";
import {
	invoiceStatusFilterButtonVariants,
} from "~/modules/billing/components/InvoicesIndexView/components/InvoiceStatusButtonFilter/invoiceStatusFilterButtonVariants.ts";
import { getInvoiceStatusIcon } from "~/modules/billing/components/InvoicesIndexView/invoicesIndexUtils.tsx";

type Props = {
	filterValues: InvoiceStatusId[];
	onChange: (newStatusFilter: InvoiceStatusId[]) => void;
};

const draftInvoiceStatuses: InvoiceStatusId[] = [invoiceStatusId.Draft, invoiceStatusId.AwaitingApproval, invoiceStatusId.Approved];

const InvoiceStatusButtonFilter = ({ filterValues, onChange }: Props) => {
	const handleOnChange = (statusId: InvoiceStatusId) => {
		let newValues;

		let statusIdsToToggle = [statusId];
		if (statusId === invoiceStatusId.Draft) {
			statusIdsToToggle = draftInvoiceStatuses;
		}

		if (filterValues.some(value => statusIdsToToggle.includes(value))) {
			newValues = filterValues.filter(id => !statusIdsToToggle.includes(id));
		} else {
			newValues = [...filterValues, ...statusIdsToToggle];
		}

		onChange(newValues);
	};

	const buttonData = useMemo(() => {
			return [
				{
					value: invoiceStatusId.Draft,
					label: "In Arbeit",
					checked: filterValues.find(value => draftInvoiceStatuses.includes(value)) !== undefined,
				},
				{
					value: invoiceStatusId.SentToClient,
					label: getInvoiceStatusDisplayNameById(invoiceStatusId.SentToClient),
					checked: filterValues.find(value => value === invoiceStatusId.SentToClient) !== undefined,
				},
				{
					value: invoiceStatusId.Paid,
					label: getInvoiceStatusDisplayNameById(invoiceStatusId.Paid),
					checked: filterValues.find(value => value === invoiceStatusId.Paid) !== undefined,
				},
				{
					value: invoiceStatusId.Reversed,
					label: getInvoiceStatusDisplayNameById(invoiceStatusId.Reversed),
					checked: filterValues.find(value => value === invoiceStatusId.Reversed) !== undefined,
				},
			];
		},
		[filterValues]);


	return (
		<div className="flex flex-row">
			{buttonData &&
				buttonData.map(({ value, label }) => {
					const checked = filterValues.includes(value);
					const { button } = invoiceStatusFilterButtonVariants({
						checked,
						size:"sm"
					});
					return (
						<Tooltip key={"status-" + value}
								 text={label}>
							<label className={button()}
								   tabIndex={0}>
								{getInvoiceStatusIcon(value, `size-5 ${!checked ? "opacity-40":""}`)}
								<input
									className="hidden"
									type="checkbox"
									checked={checked}
									onChange={() => handleOnChange(value)}
								/>
							</label>
						</Tooltip>
					);
				})}
		</div>
	);
};

export default InvoiceStatusButtonFilter;